import { Divider } from '@mui/material'

import { form } from '../../formState'
import type { ExecutionEventsFormValues, FormProps } from '../../typings'
import { useTexts } from './useTexts'

import { CustomFieldsField } from './components/CustomFieldsField'

export function CustomFields(props: FormProps) {
  const { initialValues } = props
  const hasCustomFields = Object.keys(initialValues?.customFields || {}).length > 0

  const texts = useTexts()

  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">{texts.title}</form.SectionTitle>
      {hasCustomFields && (
        <>
          <CustomFieldsField<'customFields', ExecutionEventsFormValues>
            name="customFields"
            testId="custom-fields"
          />
          <Divider />
        </>
      )}
    </form.Fieldset>
  )
}
